import React from 'react';

/**
 *@description 員工下拉選項 (含清除鈕)
 * @param {string} name 選擇框 name
 * @param {Array} options 選項
 * @param {string} value 選擇框值
 * @param {string} labelKey 選項顯示文字 key
 * @param {string} optionValue 選項值 key
 * @param {Function} onChange 選擇鈕點擊事件
 * @param {Function} onClear 清除鈕點擊事件
 * @returns {JSX.Element}
 */
export default function UserSelect({
  name,
  options,
  value,
  labelKey,
  optionValue,
  onChange,
  onClear,
}) {
  const [isHover, setIsHover] = React.useState(false);
  return (
    <div className="position-relative">
      <select
        type="select"
        className="form-select form-select-sm"
        name={name}
        value={value || ''}
        onChange={onChange}
      >
        <option disabled value="">
          請選擇
        </option>
        {options?.map((option, index) => (
          <option key={index} value={option[optionValue]}>
            {option[labelKey]}
          </option>
        ))}
      </select>
      {value && (
        <div
          className="position-absolute top-0"
          style={{
            cursor: 'pointer',
            right: '2rem',
          }}
          onClick={(e) => {
            onClear(e);
            setIsHover(false);
          }}
          onMouseEnter={() => setIsHover(true)}
          onMouseLeave={() => setIsHover(false)}
        >
          <svg
            aria-hidden="true"
            focusable="false"
            height="1em"
            role="presentation"
            viewBox="0 0 24 24"
            width="1em"
            className={`${isHover ? 'opacity-100' : 'opacity-75'}`}
          >
            <path
              d="M12 2a10 10 0 1010 10A10.016 10.016 0 0012
                 2zm3.36 12.3a.754.754 0 010 1.06.748.748 0
                 01-1.06 0l-2.3-2.3-2.3 2.3a.748.748 0 01-1.06
                 0 .754.754 0 010-1.06l2.3-2.3-2.3-2.3A.75.75
                 0 019.7 8.64l2.3 2.3 2.3-2.3a.75.75 0 011.06
                 1.06l-2.3 2.3z"
              fill="currentColor"
            ></path>
          </svg>
        </div>
      )}
    </div>
  );
}
